import React, { useState, useEffect, useRef, Fragment } from "react";
import "./styles.scss";
import { Modal } from "react-bootstrap";
import { Elements, StripeProvider } from "react-stripe-elements";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import PrimoInfo from "./PrimoInfo";
import Continue from "./Continue";
import { ReactComponent as CloseXIcon } from "../../../../public/icons/close-x-icon.svg";
import PrimoCheckoutForm from "./PrimoCheckoutForm";

function PrimoSubscriptionErrorModal(props) {
  const hocWrapper = useRef(null);
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [state, setState] = useState({
    showContinue: false,
    showDistributionModul: false,
  });

  const { current_user } = useSelector(({ current_user }) => ({
    current_user,
  }));

  const handleClick = (e) => {
    hocWrapper.current.contains(e.target) && handleShow();
  };

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        showContinue: false,
        showDistributionModul: false,
      }));
    }, 1000);
    if (props.hash) history.goBack();
    if (props.showModal) props.setSubscribeErrorModal(false);
  };
  const handleShow = () => {
    if (props.showDistributingInfo) {
      setState((prevState) => ({
        ...prevState,
        showDistributionModul: true,
      }));
    }
    setShow(true);
  };

  useEffect(() => {
    document.body.addEventListener("click", handleClick);
    return () => {
      document.body.removeEventListener("click", handleClick);
    };
  }, []);

  useEffect(() => {
    if (props.hash || props.showModal) handleShow();
    else handleClose();
  }, [props.hash, props.showModal]);

  const onCheckoutDone = () => {
    setState((prevState) => ({ ...prevState, showContinue: true }));
  };

  const onContinue = () => {
    setState((prevState) => ({
      ...prevState,
      showContinue: false,
    }));
    handleClose();
  };

  return (
    <Fragment>
      <div ref={hocWrapper} className={"hor_click " + props.className}>
        {props.children}
      </div>
      <Modal centered className="primo" show={show} onHide={handleClose}>
        <div className="d-flex justify-content-end align-items-end p-3">
          {!state.showContinue && <CloseXIcon className="close-icon" onClick={handleClose} />}
        </div>
        <Modal.Body className="text-center p-5">
          {state.showContinue ? (
            <Continue onContinue={onContinue} />
          ) : (
            <Fragment>
              <Modal.Title as="h1" className="text-dark font-weight-bold">
                UNIFI MUSIC
              </Modal.Title>
              <Fragment>
                {state.showDistributionModul ? (
                  <PrimoInfo
                    handleClose={handleClose}
                    albumId={props.albumId}
                    setDistributeAlbumSuccess={props.setDistributeAlbumSuccess}
                    setDistributeAlbumError={props.setDistributeAlbumError}
                  />
                ) : (
                  <StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}>
                    <Elements>
                      <PrimoCheckoutForm current_user={current_user} onCheckoutDone={onCheckoutDone} />
                    </Elements>
                  </StripeProvider>
                )}
              </Fragment>
            </Fragment>
          )}
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}
export default PrimoSubscriptionErrorModal;
